import React from "react";
import DataTable from "react-data-table-component";

import { useSidebarLayoutContext } from "contexts/SidebarLayoutContext";

import TableLoader from "./TableLoader";
import EmptyResult from "../Lottie/EmptyResult";

const AppTableForPrint = ({ ...props }) => {
  const { darkMode, theme } = useSidebarLayoutContext();

  const customStyles = {
    rows: {
      style: {
        "&:hover": {
          backgroundColor: theme.palette.action.hover,
        },
      },
    },
  };

  return (
    <DataTable
      pagination={false}
      progressComponent={<TableLoader />}
      noDataComponent={<EmptyResult height={200} />}
      persistTableHead={true}
      theme={darkMode ? "dark" : "default"}
      {...{ customStyles, ...props }}
    />
  );
};

export default AppTableForPrint;